import React from 'react'

const SvgWinkFaceOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.068 15.984c.923-.034 1.789-.448 2.28-1.052a1 1 0 011.552 1.262c-.903 1.11-2.34 1.736-3.757 1.79-1.438.052-2.97-.484-3.973-1.85a1 1 0 011.613-1.183c.54.736 1.383 1.067 2.285 1.033z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z'
    />
    <path d='M9.867 11.688a1 1 0 11-2 0 1 1 0 012 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.094 12.329c.305.076.507.222.57.3a.75.75 0 001.167-.943c-.324-.4-.85-.682-1.373-.812-.534-.134-1.196-.143-1.794.166a.75.75 0 10.688 1.333c.183-.095.448-.118.742-.044zM15.82 9.662c.396.117.7.338.827.509a.75.75 0 101.2-.9c-.363-.484-.97-.86-1.6-1.047-.635-.189-1.424-.222-2.126.16a.75.75 0 10.717 1.318c.245-.133.595-.155.983-.04zM8.648 8.655c-.395.118-.699.338-.827.51a.75.75 0 11-1.2-.901c.364-.484.97-.86 1.6-1.047.635-.188 1.424-.221 2.127.16a.75.75 0 11-.718 1.318c-.245-.133-.594-.155-.982-.04z'
    />
  </svg>
)

export default SvgWinkFaceOutline
